import styled from 'styled-components';

import { FormContent } from '@dreryk/react-components';

type StyledVisitFormContentProps = {
   continuouslyUsedMedicines?: boolean;
};

const StyledVisitFormContent = styled(FormContent)<StyledVisitFormContentProps>`
   grid-template-columns: 1fr ${(props) => (props.continuouslyUsedMedicines ? '2fr' : '1fr')};
   grid-template-rows: 1.25fr 1fr;
   height: 100%;
   min-height: 500px;
`;

StyledVisitFormContent.displayName = 'StyledVisitFormContent';

export { StyledVisitFormContent };
